import React, { memo, ReactNode } from 'react'
import { NonInteractiveTooltip, UltraSmallButton } from '../../custom'

export type SeriesTitleButtonProps = {
    title?: string
    onClick: () => void
    children?: ReactNode
}

const SeriesTitleButton = ({ title, onClick, children }: SeriesTitleButtonProps) => (
    <NonInteractiveTooltip placement="top" title="Change symbol" arrow>
        <UltraSmallButton
            size="small"
            variant="text"
            color="inherit"
            sx={{
                padding: 0,
                margin: 0,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.5,
                maxHeight: '24px',
                borderRadius: '2px',
                minWidth: 0,
            }}
            onClick={onClick}
        >
            {children ?? title}
        </UltraSmallButton>
    </NonInteractiveTooltip>
)

export default memo(SeriesTitleButton)
